import { CLUSTER_ENV, ENV } from '../configs/env';

export const getCluster = () => process.env.CLUSTER_ENV || CLUSTER_ENV.US;

export const isMX = () => getCluster() === CLUSTER_ENV.MX;

export const isUS = () => getCluster() === CLUSTER_ENV.US;

export const getHost = () => {
    if (process.env.BUILD_ENV === ENV.SIM) {
        if (/didifinance\.com/.test(window.location.host)) {
            return '.didifinance.com';
        } else {
            return '.xiaojukeji.com';
        }
    }

    if (process.env.BUILD_ENV === ENV.DEV) {
        return window.location.hostname;
    }

    if (/didifinance\.com/.test(window.location.host)) {
        return '.didifinance.com';
    } else {
        return '.didiglobal.com';
    }
};

export const isDidifinanceHost = () => /didifinance\.com/.test(window.location.host);

export const isDidifinanceUrl = (url: string) => /didifinance\.com/.test(url);
